import React, { Component, useState } from 'react';
import { Loader } from 'semantic-ui-react';

export default class LoadScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {};    
    }

    render(){
        return(
            this.props.isLoading ? 
                <div
                    style={{
                        position: 'fixed',
                        display: 'flex',
                        alignItems: 'center',
                        top: '0px',
                        left: '0px',
                        backgroundColor: 'rgba(0, 0, 0, .8)',
                        height: '100%',
                        width: '100%',
                        zIndex: 999999,
                    }}
                >
                    <Loader style={{ color: 'white' }} active size='huge'>
                        {this.props.text ? this.props.text : 'Carregando ...'}
                    </Loader>
                </div> 
                : null
        )
    }
}